import mergeLabels from './merge-labels'

export default mergeLabels
